<template>
  <v-col cols="12">
    <Loader
      v-if="loading"
      :key="generateUniqueId()"
      :loader-state="loading"
    ></Loader>

    <v-card>
      <v-card-title>Spots TV</v-card-title>

      <v-card-text>
        <div class="global-actions">
          <router-link :to="{ name: 'tvSpotCreate' }">
            <v-btn
              small
              color="primary"
              class="mt-5"
            >
              Ajouter un spot TV
            </v-btn>
          </router-link>
        </div>
      </v-card-text>

      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-uppercase">
                Titre
              </th>
              <th class="text-center text-uppercase">
                Position
              </th>
              <th class="text-center text-uppercase">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(tvSpot, tvSpotIndex) in tvSpots"
              :key="'c'+ tvSpotIndex"
            >
              <td class="font-weight-bold">
                {{ resolveAttrValue(tvSpot, 'title') }}
              </td>
              <td class="text-center">
                {{ tvSpot.position ? tvSpot.position : '-' }}
              </td>
              <td class="text-center">
                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-btn
                      color="warning"
                      fab
                      dark
                      x-small
                      v-bind="attrs"
                      :to="{ name: 'tvSpotDetails', params: { tvSpotId: tvSpot.id }}"
                    >
                      <v-icon dark>
                        {{ icons.mdiPen }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Consulter</span>
                </v-tooltip>

                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-btn
                      class="ml-2"
                      color="error"
                      fab
                      dark
                      x-small
                      v-bind="attrs"
                      @click="openDeleteTvSpotDialog(tvSpot)"
                    >
                      <v-icon dark>
                        {{ icons.mdiTrashCan }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Supprimer</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <DeleteTvSpotDialog
        :key="Date.now()"
        :delete-tv-spot-dialog-state="deleteTvSpotDialogState"
        :tv-spot="tvSpotToDelete"
        @closeDeleteTvSpotDialog="closeDeleteTvSpotDialog($event)"
      ></DeleteTvSpotDialog>
    </v-card>
  </v-col>
</template>

<script>
import { mdiPen, mdiBackupRestore, mdiDatabaseSearchOutline, mdiTrashCan } from '@mdi/js'
import Vue from 'vue'
import config from '../../../config'
import Loader from '@/components/Common/Loader'
import DeleteTvSpotDialog from '@/components/Dialog/TvSpot/DeleteTvSpotDialog'

export default {
  components: { DeleteTvSpotDialog, Loader },
  data: () => ({
    loading: false,
    tvSpots: [],
    nextPage: 1,
    tvSpotToDelete: null,
    deleteTvSpotDialogState: false,
    icons: {
      mdiPen,
      mdiBackupRestore,
      mdiDatabaseSearchOutline,
      mdiTrashCan
    }
  }),
  computed: {
    isHandlingTvSpotScroll () {
      return this.$store.getters.isHandlingTvSpotScroll
    }
  },
  watch: {
    $route: function () {
      this.tvSpots = []
      this.nextPage = 1
      this.getTvSpots()
    }
  },
  created () {
    this.getTvSpots()

    window.removeEventListener('scroll', this.handleScroll)

    setTimeout(() => {
      window.addEventListener('scroll', this.handleScroll)
    }, 1000)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      const wrapperOffsetHeight = document.querySelector('.v-application--wrap').offsetHeight
      const bottomOfWindow = (document.documentElement.scrollTop + window.innerHeight) === wrapperOffsetHeight

      if (bottomOfWindow && !this.isHandlingTvSpotScroll) {
        this.getTvSpots()
      }
    },
    getTvSpots () {
      this.loading = true

      const params = {
        page: this.nextPage
      }

      this.$store.commit('setHandlingTvSpotScroll', true)

      Vue.prototype.$http
        .get(config.apiUrl + '/api/tv-spots', {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          },
          params: params
        })
        .then(response => {
          if (response.status === 200) {
            const tvSpots = response.data

            if (tvSpots && tvSpots.length) {
              this.tvSpots.push(...tvSpots)

              this.nextPage = this.nextPage + 1
            }
          }

          this.loading = false
          this.$store.commit('setHandlingTvSpotScroll', false)
        })
        .catch(() => {
          this.loading = false
          this.$store.commit('setHandlingTvSpotScroll', false)
        })
    },
    openDeleteTvSpotDialog (tvSpot) {
      this.deleteTvSpotDialogState = true
      this.tvSpotToDelete = tvSpot
    },
    closeDeleteTvSpotDialog (deleteState) {
      if (deleteState === true) {
        this.tvSpots = this.tvSpots.filter(element => element.id !== this.tvSpotToDelete.id)
      }

      this.deleteTvSpotDialogState = false
    },
    resolveAttrValue (data, attr) {
      const translations = data.translations

      if (translations && translations.fr) {
        return translations.fr[attr]
      }

      if (data && data[attr]) {
        return data[attr]
      }

      return '-'
    }
  }
}
</script>

<style lang="scss">
.global-actions {
  margin-bottom: 1rem;
}
.action {
  margin-right: 0.5rem;
}
.v-chip-light-bg {
  margin-right: 0.5rem;
}
.clear {
  clear: both;
}
</style>
